import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { FuncsService } from './services/funcs.service';
import { CustomerCurrent } from './data/customer';
import { environment } from '../environments/environment';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})

export class AppComponent {
  title = 'Ford Diagnostic Subscriptions';
  user_name = "";
  full_name = "";
  dealer = "";
  role = "";

  navClass = "";
  prod: boolean = environment.production;
  admin: boolean = false;

  constructor(
    private funcs: FuncsService,
    private router: Router
  ) { }

  ngOnInit() {  
    const currentUrl = this.router.url;
    
    if (currentUrl.startsWith('/auto-login')) {
      return;
    }

    if (localStorage.getItem("customer")) {
      this.funcs.currentCustomer(CustomerCurrent);
    }

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.loadCustomerInfo();
      });

    if (this.funcs.isAdminRole(CustomerCurrent.role)) {
      this.admin = true;
    }

    this.loadCustomerInfo();
  }

  loadCustomerInfo() {
    if (CustomerCurrent) {
      this.user_name = CustomerCurrent.username;
      this.full_name = CustomerCurrent.name;
      this.dealer = CustomerCurrent.pa_code;
      this.role = CustomerCurrent.role;
    } else {
      this.user_name = "";
      this.full_name = "";
      this.dealer = "";
      this.role = "";
      this.admin = false;
    }
  }

  logout(): void {
    this.funcs.logOutCustomer();
    this.user_name = "";
    this.full_name = "";
    this.dealer = "";
    this.role = "";
    this.navClass = "";
    this.admin = false;
  }

  showNav() {
    this.navClass = (!this.navClass) ? "active" : "";
  }
  closeNavIfOpen(): void {
    this.navClass = "";
  }
}